import {RadioGroup, RadioGroupItem} from "../../shadCn/components/ui/RadioGroup";
import React from "react";
import { Label as StyledLabel } from "../drawer/SearchDrawerOpener";
import { Label } from "../../shadCn/components/ui/label"


function SearchComponentRadioGroup({title, value, type, listener}){

    return(
        <>
            <div className={"m-3 flex"}>
                <StyledLabel className={"mr-2"}> {title} : </StyledLabel>
                <RadioGroup
                    defaultValue={value}
                    onValueChange={listener}
                    className={"flex gap-5"}
                >
                    {type.map((item, index) =>
                        <div key={index} className="flex items-center space-x-2">
                            <RadioGroupItem value={`${item.value}`} id={`${item.id ? item.id : item.value}`}/>
                            <Label
                                htmlFor={`${item.id ? item.id : item.value}`}
                                className={"cursor-pointer" + (item.red ? " text-red-500" : "")}
                            >
                                {item.text}
                            </Label>
                        </div>
                    )}
                </RadioGroup>
            </div>
        </>
    );
}

    export default SearchComponentRadioGroup;
